export default __webpack_public_path__ + "static/media/eb-wht-3.57e064a7.png";